import { makeStyles } from 'tss-react/mui';

export const useSplitsViewStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.light}`,
    boxShadow: theme.shadows[7],
    borderRadius: 12,
    marginTop: 24,
  },
  rootSeries: {
    boxShadow: theme.shadows[1],
    marginTop: 0,
    width: '100%',
  },
  titleIconGroup: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '8px 24px 0px 24px',
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },
  titleIconGroupSeries: {
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.border.light}`,
  },
  titleWithIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  repeatIcon: {
    height: 18,
    width: 18,
    color: theme.palette.icon.light,
  },
  toggleButtons: {
    color: theme.palette.primary.main,
    borderRadius: 22,
    marginRight: -14,
  },
  editButton: {
    padding: '6px 8px',
    minWidth: 'unset',
    textTransform: 'none',
  },
  rowRoot: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'hidden',
    margin: '12px 12px',
  },
  rowRootSeries: {
    margin: 0,
    padding: '12px 16px',
    alignItems: 'flex-start',
  },
  preview: {
    width: '100%',
    textAlign: 'left',
    fontWeight: 500,
  },
  amountWidth: {
    minWidth: 60,
    height: '100%',
    alignSelf: 'start',
    textAlign: 'right',
  },
  amountWidthSeries: {
    minWidth: 120,
  },
  splitPadding: {
    padding: '0px 12px',
  },
  splitPaddingSeries: {
    padding: 0,
  },
  showAllButton: {
    width: '100%',
    paddingTop: 8,
    paddingBottom: 8,
  },
  chip: {
    margin: 4,
    height: 28,
    maxWidth: 140,
    minWidth: 40,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    borderRadius: 22,
    border: 'none',
  },
  inputField: {
    fontSize: 16,
    textAlign: 'right',
  },
  overflowAmount: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 6,
    color: theme.palette.text.secondary,
    paddingTop: 8,
  },
  overflowAmountSeries: {
    paddingTop: 0,
  },
  splitTags: {
    display: 'flex',
    flexFlow: 'wrap',
  },
  catRow: {
    display: 'flex',
    gap: 8,
  },
  seriesLeftGrid: {
    display: 'grid',
    gridTemplateColumns: '232px 266px',
    columnGap: 16,
    alignItems: 'start',
    width: '100%',
    minWidth: 0,
  },
  seriesCell: {
    minWidth: 0,
  },
  categoryText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  padding: {
    // prevents icon from off-centering
    display: 'flex',
    padding: 0.5,
  },
  infoIcon: {
    color: theme.palette.icon.light,
    marginLeft: 8,
    height: 18,
    width: 18,
  },
}));
